"use client";

import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";

const Header = () => {
  const controls = useAnimation();

  useEffect(() => {
    const sequence = async () => {
      await controls.start({
        width: "80%",
        transition: { duration: 1, ease: "easeOut" },
      });
      await controls.start({
        width: "100%",
        height: "100%",
        borderRadius: 0,

        transition: { duration: 1.2, ease: "easeOut" },
      });
    };

    if (controls) {
      sequence();
    }
  }, [controls]);

  return (
    <header className="relative top-0 right-0 left-0 -z-10 flex h-screen max-h-[1400px] items-center justify-center overflow-hidden">
      <div className="from-secondary-main absolute top-0 right-0 left-0 z-10 h-1/4 bg-gradient-to-b to-transparent" />
      <motion.figure
        className="overflow-hidden"
        animate={controls}
        initial={{ height: "75%", width: 0, borderRadius: 30 }}
      >
        <video
          autoPlay
          muted
          playsInline
          loop
          className="min-h-full min-w-full object-cover"
        >
          <source src={"/videos/home-header.mp4"} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </motion.figure>
      <div className="from-secondary-main absolute right-0 bottom-0 left-0 z-10 h-1/4 bg-gradient-to-t to-transparent transition-colors duration-700" />
    </header>
  );
};

export default Header;
